import {
	ACCOUNT_TYPE_CODE_CONSORTIUM,
	ACCOUNT_TYPE_CODE_PROGRAM,
	ACCOUNT_TYPE_CODE_LESSSEE,
	ACCOUNT_TYPE_CODE_VENDOR_PROGRAM,
} from '../../constants/account';
import { ACCOUNT_LABEL, CONSORTIUM_LABEL, PROGRAM_LABEL, VENDOR_PROGRAM_LABEL } from '../../constants/messages';

export interface Account {
	accountId: number;
	accountName: string;
	accountTypeCode: string;
	accountType: string;
	accountStatus: string;
	consortiumId: number;
	consortiumName: string;
	consortiumStatus: string;

	// Relationship Information
	leadAccountId?: number;
	consortiumDetailsId?: number;
	consortiumDetailsStatus?: string;
	ownerId: number;
	ownerStatus?: string;

	// Source Information
	sourceId: number;
	sourceTypeCode?: string;
	sourceType?: string;
	sourceName?: string;

	// Consortium Account Details
	consortiumAccountsId?: number;
	consortiumAccountsStatus?: string;
}

export function accountNameFromType(account: Account): string {
	if (!account || !account.accountTypeCode) {
		return ACCOUNT_LABEL + '';
	}

	switch (account.accountTypeCode) {
		case ACCOUNT_TYPE_CODE_CONSORTIUM:
			return CONSORTIUM_LABEL + account.accountName;
		case ACCOUNT_TYPE_CODE_PROGRAM:
			return PROGRAM_LABEL + account.accountName;
		case ACCOUNT_TYPE_CODE_VENDOR_PROGRAM:
			return VENDOR_PROGRAM_LABEL + account.accountName;
		case ACCOUNT_TYPE_CODE_LESSSEE:
		default:
			return ACCOUNT_LABEL + account.accountName;
	}
}

export function accountNameWithoutType(accountLabel: string): string {
	const labelRegex = new RegExp(
		`(${[ACCOUNT_LABEL, CONSORTIUM_LABEL, PROGRAM_LABEL, VENDOR_PROGRAM_LABEL]
		.map(label => label.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')).join('|')})`
	);
	return accountLabel.replace(labelRegex, '').trim();
}
